import React, {useEffect, useState} from "react"
import useGoBack from "@Routing/hooks/useGoBack"
import PriceChangeModal from "@CheckOrder/features/modals/components/PriceChangeModal";
import ExpiredSessionModal from "@CheckOrder/features/modals/components/ExpiredSessionModal";
import GenericCheckOrderErrorModal from "@CheckOrder/features/modals/components/GenericCheckOrderErrorModal";
import useDialog from "@Features/dialog/hooks/useDialog";
import GenericErrorModalType from "@CheckOrder/features/modals/types/GenericErrorModal.type";
import useOpenCheckOrderModals from "@CheckOrder/features/modals/hooks/useOpenCheckOrderModals";

function CheckOrderModals() {
    const {goBack} = useGoBack()
    const [genericError, setGenericError] = useState<GenericErrorModalType>()

    const {
        dialogRef: expiredSessionModalRef,
        openModal: openExpiredSessionModal,
        closeModal: closeExpiredSessionModal,
    } = useDialog({onClose: goBack})

    const {
        dialogRef: priceChangeModalRef,
        openModal: openPriceChangeModal,
        closeModal: closePriceChangeModal,
    } = useDialog({onClose: goBack})

    const {
        dialogRef: genericErrorModalRef,
        openModal: openGenericErrorModal,
    } = useDialog()

    useOpenCheckOrderModals({openExpiredSessionModal, openPriceChangeModal, setGenericError})

    useEffect(() => {
        if (genericError) {
            openGenericErrorModal()
        }
    }, [genericError]);

    return (
        <>
            <ExpiredSessionModal
                dialogRef={expiredSessionModalRef}
                closeModal={closeExpiredSessionModal}
            />
            <PriceChangeModal
                dialogRef={priceChangeModalRef}
                closeModal={closePriceChangeModal}
            />
            <GenericCheckOrderErrorModal
                dialogRef={genericErrorModalRef}
                closeModal={genericError?.action}
                title={genericError?.title}
                isInlineHtml={genericError?.isInlineHtml}
                message={genericError?.message}
                btnText={genericError?.btnText}
            />
        </>
    )
}

export default CheckOrderModals